export default __webpack_public_path__ + "static/media/ReconVelocityLogoWordMark_gray.f46d795b.png";